import { ImgHTMLAttributes, ReactNode } from "react";
import { ReactMarkdownOptions } from "react-markdown/lib/react-markdown";

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src?: string;
  alt?: string;
  "data-thumbnail"?: string;
}

interface VideoProps {
  src?: string;
  type?: string;
}

interface LinkProps {
  href?: string;
  children: ReactNode;
  title?: string;
}

export const renderers: ReactMarkdownOptions["components"] = {
  img: ({ src, alt, className, "data-thumbnail": dataThumbnail }: ImageProps) => {
    const imgClass = dataThumbnail ? "pdf-thumbnail" : "responsive-media";
    return <img src={src} alt={alt} className={imgClass} />;
  },
  video: ({ src, type }: VideoProps) => (
    <video controls className="responsive-media">
      <source src={src} type={type} />
      Your browser does not support the video tag.
    </video>
  ),
  link: ({ href = "", children, title }: LinkProps) => {
    let thumbnailUrl = "";
    if (title && title.startsWith("https://")) {
      thumbnailUrl = title;
    }

    if (href.endsWith(".pdf")) {
      return (
        <a href={href} target="_blank" rel="noopener noreferrer">
          <img src={thumbnailUrl} alt="PDF Thumbnail" className="pdf-thumbnail" data-thumbnail="true" />
          {children}
        </a>
      );
    }
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  },
};
